import React from 'react'
import { NativeSelect } from '@chakra-ui/react'

export default ({ bg, w, maxW, placeholder, size, variant, children, value, onChange, disabled }) => {
  return (
    <NativeSelect.Root bg={bg} size={size} w={w} maxW={maxW} variant={variant} disabled={disabled}>
      <NativeSelect.Field placeholder={placeholder} value={value} onChange={onChange} disabled={disabled}>
        {children}
      </NativeSelect.Field>
      <NativeSelect.Indicator />
    </NativeSelect.Root>
  )
}
